import { http } from "../http/Http";
import { TaskTypeCustomComponent } from "../models/TaskTypeCustomComponent";
import { ServiceResponse } from "../models/ServiceResponse";
import { GetByFiltersArguments } from "../models/GetByFiltersArguments";

export class TaskTypeCustomComponentService {

    getTaskTypeCustomComponentsByFilters = async (apiQueryFilter: GetByFiltersArguments): Promise<ServiceResponse<TaskTypeCustomComponent[]>> => {
        const { data } = await http.post<ServiceResponse<TaskTypeCustomComponent[]>>("TaskTypeCustomComponent/GetByFilters", apiQueryFilter);
        return data;
    };

    getTaskTypeCustomComponent = async (id: number): Promise<TaskTypeCustomComponent> => {
        const { data } = await http.get<TaskTypeCustomComponent>(("TaskTypeCustomComponent/GetById/" + id.toString()));
        return data;
    };

}